export default "<div class=\"{{panel}}\">\r\n  <ng-content></ng-content>\r\n</div>\r\n";